export const LOGIC_COL = {
  ITEM_NAME: 'item_name',
  STORE_NAME: 'store_name',
  ITEM_CATEGORY: 'item_category',
  CHANNEL: 'channel',
  COLUMN: 'columns',
  GENDER: 'gender',
  SELLER_ADDRESS: 'seller_address',
  UNIT_PRICE: 'unit_price',
  AMOUNT: 'amount',
  BIRTH_YEAR: 'birth_year'
}
const { ITEM_NAME, STORE_NAME, ITEM_CATEGORY, CHANNEL, COLUMN, GENDER, SELLER_ADDRESS, UNIT_PRICE, AMOUNT, BIRTH_YEAR } = LOGIC_COL

const operator = {
  INCLUDE: 'include',
  EXCLUDE: 'exclude',
  EQUAL: 'Equal',
  NOT_EQUAL: 'NotEqual',
  GT: 'Gt',
  GTE: 'Gte',
  LT: 'Lt',
  LTE: 'Lte'
}
const { INCLUDE, EXCLUDE, EQUAL, NOT_EQUAL, GT, GTE, LT, LTE } = operator
const INT_OPERATOR = [EQUAL, NOT_EQUAL, GT, GTE, LT, LTE]

export const optionConf = ln_t => ({
  [ITEM_NAME]: { value: ITEM_NAME, label: ln_t('invoice.itemName'), multipleSelection: true, operator: [INCLUDE, EXCLUDE], example: '(ex: 咖啡,飼料,雀巢)' },
  [STORE_NAME]: { value: STORE_NAME, label: ln_t('invoice.storeName'), multipleSelection: true, operator: [INCLUDE, EXCLUDE], example: '(ex: 全家,全聯)' },
  [ITEM_CATEGORY]: { value: ITEM_CATEGORY, label: ln_t('invoice.itemCategory'), useSelector: true, multipleSelection: true, operator: [INCLUDE, EXCLUDE] },
  [CHANNEL]: { value: CHANNEL, label: ln_t('invoice.channel'), useSelector: true, multipleSelection: true, operator: [INCLUDE, EXCLUDE] },
  [COLUMN]: { value: COLUMN, label: ln_t('invoice.columns'), useSelector: true, multipleSelection: true, operator: [INCLUDE, EXCLUDE] },
  [GENDER]: { value: GENDER, label: ln_t('invoice.gender'), useSelector: true, multipleSelection: true, operator: [INCLUDE] },
  [SELLER_ADDRESS]: { value: SELLER_ADDRESS, useSelector: true, multipleSelection: true, label: ln_t('invoice.sellerAddress'), operator: [INCLUDE] },
  [UNIT_PRICE]: { value: UNIT_PRICE, label: ln_t('invoice.unitPrice'), operator: INT_OPERATOR },
  [AMOUNT]: { value: AMOUNT, label: ln_t('invoice.amount'), operator: INT_OPERATOR },
  [BIRTH_YEAR]: { value: BIRTH_YEAR, label: ln_t('invoice.birthYear'), operator: INT_OPERATOR }
})

export const invoiceLogicColOptions = [ITEM_NAME, STORE_NAME, ITEM_CATEGORY, CHANNEL, COLUMN]

export const audienceLogicColOptions = [ITEM_CATEGORY, ITEM_NAME, CHANNEL, STORE_NAME, GENDER, SELLER_ADDRESS, UNIT_PRICE, AMOUNT, BIRTH_YEAR]
